import React from 'react';
import { ISimpleSubProduct } from '../types';
import Money from '../../../Money';
import SimpleSubTooltip from './SimpleSubTooltip';
import getRcDiscountedPrice from '../utils/getRcDiscountedPrice';
import getTasteStrFromTag from '../../../../../scripts/utils/getTasteStrFromTag';
import countRoast from '../../../../../scripts/utils/countRoast';
import RoastBeans from '../../../RoastBeans';

interface SimpleSubProductProps {
  langStrings: Record<string, string>;
  product: ISimpleSubProduct;
  simpleSubProducts: ISimpleSubProduct[];
  setSimpleSubProducts: React.Dispatch<React.SetStateAction<ISimpleSubProduct[]>>;
}

const SimpleSubProduct: React.FunctionComponent<SimpleSubProductProps> = ({
  langStrings,
  product,
  simpleSubProducts,
  setSimpleSubProducts
}: SimpleSubProductProps) => {
  // E.g. Colombia El Carmen - 10 pods
  const titleArr: string[] = product.title.split(' - ');
  const titleOnly: string = titleArr[0];

  const packDetailsArr: string[] = titleArr[1]?.split(' ');
  const packQty: string = packDetailsArr && packDetailsArr[0];
  const packType: string = packDetailsArr && packDetailsArr[1];

  const handleQtyChange = (type: string) => {
    const clonedProducts: ISimpleSubProduct[] = [...simpleSubProducts];

    clonedProducts.forEach((prod: ISimpleSubProduct) => {
      if (prod.id !== product.id) return;

      if (type === 'inc') {
        prod.numAdded++;
      } else {
        prod.numAdded > 0 && prod.numAdded--;
      }
    });

    setSimpleSubProducts(clonedProducts);
  };

  const handleVariantChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const variantId = event.target.value;
    const clonedProducts: ISimpleSubProduct[] = [...simpleSubProducts];

    clonedProducts.forEach((prod: ISimpleSubProduct) => {
      if (prod.id !== product.id) return;

      prod.selectedVariantId = +variantId;
    });
    console.log(simpleSubProducts)
    setSimpleSubProducts(clonedProducts);
  };

  let prodPrice: number = product.price;

  const discountedPrice: number = getRcDiscountedPrice(product);

  if (discountedPrice) {
    prodPrice = discountedPrice;
  }

  const extraQtyActiveClass: string = product.numAdded > 0 ? ' simple-sub-product-qty-txt--active' : '';
  const roastCount: number = countRoast(product);
  const tasteStr: string = getTasteStrFromTag(product);

  return (
    <div className="simple-sub-product" aria-label="Simple Subscription Product">
      <div className="simple-sub-product-container">
        <div className="simple-sub-product-img-wrap">
          {product.mostPopular && (
            <div className="simple-sub-product-popular">
              <p className="simple-sub-product-popular-txt">
                {langStrings.mostPopular}
              </p>
            </div>
          )}

          <a href={product.url}>
            <img className="simple-sub-product-img" src={product.imageUrl} alt={product.title} width={164} height={164} />
          </a>

          <div className="simple-sub-product-img-tooltip">
            <SimpleSubTooltip
              langStrings={langStrings}
              product={product}
            />
          </div>
        </div>

        <div className="simple-sub-product-content">
          <a href={product.url}>
            <h3 className="simple-sub-product-title">{titleOnly}</h3>
          </a>
          {product.variants.length <= 1 &&
            <div className="simple-sub-product-details">
              <p className="simple-sub-product-price">
                <Money amount={prodPrice} />
              </p>
              {packQty && packType && (
                <p className="simple-sub-product-size">{packQty} x {packType}</p>
              )}
            </div>
          }
          <div className="simple-sub-product-taste-container">
            {tasteStr &&
              <div className="simple-sub-tooltip-taste">
                <p className="simple-sub-tooltip-taste-txt">{langStrings.tastesLike} <span>{tasteStr}</span></p>
              </div>
            }
            {roastCount > 0 &&
              <div className="simple-sub-tooltip-roast">
                <h5 className="simple-sub-tooltip-roast-title">
                  {langStrings.roast}
                </h5>
                <RoastBeans roastCount={roastCount} />
              </div>
            }
          </div>
        </div>
        <div className="simple-sub-product-tooltip">
          <SimpleSubTooltip
            langStrings={langStrings}
            product={product}
          />
        </div>
      </div>
      <div className={`simple-sub-product-selection${product.variants.length <= 1 ? ' simple-sub-product-selection--no-variants' : ''}`}>
        {product.variants.length > 1 &&
          <div className="simple-sub-product-variant">
            <select
              className="select simple-sub-product-variant-select simple-sub-main-sect-two-freq"
              name="simple-sub-product-variant-select"
              onChange={handleVariantChange}
            >
              {product.variants.map((variant, index) => (
                <option value={variant.id} key={index}>{variant.title}</option>
              ))}
            </select>

          </div>
        }
        <div className={`quantity-selector-wrapper simple-sub-product-qty-wrap${product.variants.length <= 1 ? ' simple-sub-product-qty-wrap--no-variants' : ''}`}>
          <button
            role="button"
            type="button"
            className="btn-quantity-selector btn-dec"
            aria-label="Decrease Quantity"
            onClick={() => handleQtyChange('dec')}
          >
          </button>
          <input
            type="number"
            className={'text-input input-quantity simple-sub-product-qty-txt' + extraQtyActiveClass}
            value={product.numAdded}
            aria-label={product.numAdded > 0 ? 'Item Quantity - Active' : 'Item Quantity'}
            readOnly
          />
          <button
            role="button"
            type="button"
            className="btn-quantity-selector btn-inc"
            aria-label="Increase Quantity"
            onClick={() => handleQtyChange('inc')}
          >
          </button>
        </div>
      </div>
    </div>
  );
};

export default SimpleSubProduct;